import { pilot } from '~/services/serviceInstances';

interface Request {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    avatar?: string;
    client?: number;
  };
}
export const updateCurrentUser = ({ user }: Request) => {
  const params = {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    avatar: user.avatar,
    client: user.client,
  };
  return pilot.put('/user/my-profile/', params);
};
